<template>
  <div class="enter-community-container">
    <el-card>
      <div slot="header" class=" flex justify-between">
        论坛审核
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" style="display: flex;">
        <el-form-item label="">
          <el-input v-model="searchForm.name" clearable :placeholder="$t('forumText.memberName')"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="searchForm.reviewStatus" clearable :placeholder="$t('forumText.reviewStatus')">
            <el-option :label="value" :value="key" :key="key"
              v-for="(value, key) in $t('forumText.reviewStatusOptions')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">{{ $t('common.search') }}</el-button>
          <el-button type="primary" plain @click="onReset">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="communityList" border v-loading="loading">
        <el-table-column prop="memberName" :label="$t('forumText.memberName')" align="center" />
        <el-table-column prop="content" :label="$t('forumText.content')" align="center" width="400" />
        <el-table-column :label="$t('forumText.imgUrls')" align="center">
          <template slot-scope="{ row }">
            <el-image style="width: 100px; height: 100px" :src="getImagesSingle(row.imgUrls)" fit="cover"
              :preview-src-list="row.imgUrls ? row.imgUrls.split(',') : []">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="likeCount" :label="$t('forumText.likeCount')" align="center" />
        <el-table-column prop="commentCount" :label="$t('forumText.commentCount')" align="center" />
        <el-table-column prop="releaseTime" :label="$t('forumText.releaseTime')" align="center" />
        <el-table-column :label="$t('forumText.reviewStatus')" align="center">
          <template slot-scope="{ row }">
            {{ statusMap[row.reviewStatus] || row.reviewStatus }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('forumText.operation')" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="row.reviewStatus == '0'" type="text" size="small" @click="goCheck(row)"
              style="margin-right: 20px;">
              {{ $t('forumText.check') }}
            </el-button>
            <el-popconfirm :title="$t('forumText.isDelete')" @confirm="deleteFo(row.articleId)">
              <el-button slot="reference" type="text" size="small">{{ $t('forumText.delete') }}</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handlePageChange" />
    </el-card>
    <!-- 审核确认弹窗 -->
    <el-dialog :title="$t('forumText.check')" :visible.sync="showPayModal" width="20%">
      <el-form label-width="120px" class="text-left" label-position="top" :model="form" :rules="rules" ref="ruleForm">
        <el-form-item :label="$t('forumText.isCheckText')" required prop="reviewStatus">
          <el-select v-model="form.reviewStatus" :placeholder="$t('forumText.selectPlaceholder')">
            <el-option :label="$t('forumText.normal')" :value="1"></el-option>
            <el-option :label="$t('forumText.refuse')" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPayModal = false">{{ $t('common.close') }}</el-button>
        <el-button type="primary" @click="checkForum()">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryForumList, judgeForum, deleteForum } from '@/api/forum/forumApi.js'
export default {
  name: 'forumTextList',
  data() {
    return {
      showPayModal: false,
      loading: false,
      communityList: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      statusMap: {
        0: this.$t('forumText.reviewStatusOptions.0'),
        1: this.$t('forumText.reviewStatusOptions.1'),
        2: this.$t('forumText.reviewStatusOptions.2')
      },
      activeRow: '',
      searchForm: {
        name: '',
        reviewStatus: ''
      },
      form: {
        reviewStatus: ''
      },
      rules: {
        reviewStatus: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getForumList()
  },
  methods: {
    // 删除
    deleteFo(articleId) {
      deleteForum({ articleId }).then(res => {
        if (res.code == 0) this.getForumList()
      })
    },
    // 搜索
    onSearch() {
      this.pagination.current = 1
      this.getForumList()
    },
    // 重置
    onReset() {
      this.searchForm = {}
      this.getForumList()
    },
    // 审核
    goCheck(row) {
      this.showPayModal = true
      this.activeRow = row
    },
    // 获取列表
    async getForumList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          communityId: this.getCommunityId(),
          ...this.searchForm
        }
        const res = await queryForumList(params)
        this.communityList = res.data
        this.pagination.total = res.data.total
      } catch (error) {
        this.$message.error(error.message || this.$t('forumText.fetchError'))
      } finally {
        this.loading = false
      }
    },
    // 获取图片
    getImagesSingle(images) {
      return images ? images.split(',')[0] : ''
    },
    // 确认审核
    checkForum() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          judgeForum({ articleId: this.activeRow.articleId, reviewStatus: this.form.reviewStatus }).then(res => {
            if (res.code == 0) {
              this.showPayModal = false
              this.getForumList()
            }
          })
        } else {
          this.$message.error(this.$t('common.fetchError'))
          return false;
        }
      });
    },
    handlePageChange(page) {
      this.pagination.current = page
      this.getForumList()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.getForumList()
    }
  }
}
</script>

<style scoped>
.enter-community-container {
  padding: 20px;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.float-right {
  float: right;
}

.commercial-content {
  text-align: center;
  padding: 20px 0;
}

.commercial-content img {
  max-width: 100%;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>